import {ApplicationRef, Component, ComponentFactoryResolver, Inject, Injector, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {environment} from '@env/environment';
import {KeyIdentifierModel} from '@service/models';
import {DomPortalOutlet, PortalOutlet, TemplatePortal} from '@angular/cdk/portal';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AppConfigService} from '@service/config/app-config.service';
import {ProgressButtonOptions} from '@service/models/interfaces/progress-button.interface';
import {CommonFinanceService} from '@service/services/common-services/common-finance.service';
import {ContentService} from '../../../../constants/content.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'm-deposit-final-consent-modal',
    templateUrl: './deposit-final-consent-modal.component.html',
    styleUrls: ['./deposit-final-consent-modal.component.scss']
})
export class DepositFinalConsentModalComponent implements OnInit {

    @ViewChild('htmlPdf', {static: true}) htmlPdfRef;
    @ViewChild('iframe', {static: true}) iframe;
    private portalHost: PortalOutlet;
    barButtonOptions: ProgressButtonOptions = {
        active: false,
        text: 'Accept & Continue',
        buttonColor: 'primary',
        // @ts-ignore
        flat: true,
        stroked: false,
        disabled: false
    };
    downloadButtonOptions: ProgressButtonOptions = {
        active: false,
        text: 'Download',
        buttonColor: 'primary',
        // @ts-ignore
        raised: false,
        stroked: true,
        disabled: false
    };
    employerName: string = '';
    keyIdentifier: KeyIdentifierModel;
    subProductName: string;
    appConfig: any;
    headerLogo = environment.s3Url + 'images/' + environment.institutionId + '/logo.png';
    logo = environment.s3Url + 'images/' + environment.institutionId + '/loading.gif';
    depositFinalConsentHTML: string | SafeHtml;
    showLogo = true;
    isCoApplicant = false;
    // depositFinalConsentHTML: HTMLHtmlElement = document.querySelector('#depositFinalConsentHTML');
    errorMessage = false;
    consentHtml = '';

    constructor(public dialogRef: MatDialogRef<DepositFinalConsentModalComponent>,
                private componentFactoryResolver: ComponentFactoryResolver,
                private injector: Injector,
                private appRef: ApplicationRef,
                private viewContainerRef: ViewContainerRef,
                private _sanitizer: DomSanitizer,
                public contentService: ContentService,
                private commonFinanceService: CommonFinanceService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.appConfig = AppConfigService.config;
        if (data.showLogo === 'no') {
            this.showLogo = false;
        }

        this.isCoApplicant = !!data.isCoApplicant;
    }

    ngOnInit() {
        // this.depositFinalConsentHTML.innerHTML = 'https://creditsnap-public.s3.amazonaws.com/html/' + environment.institutionId + '/final-consent.html';
        this.commonFinanceService.getConsentHTMLFromS3(this.isCoApplicant).then((data) => {
            this.consentHtml = data;
            this.depositFinalConsentHTML = this._sanitizer.bypassSecurityTrustHtml(this.consentHtml);
        });
    }

    accept() {
        this.errorMessage = false;
        const checkForCheckboxes = this.htmlPdfRef.elementRef.nativeElement.parentElement?.querySelectorAll('input[type="checkbox"]');
        let isValid = true;
        if (checkForCheckboxes.length > 0) {
            checkForCheckboxes.forEach((checkbox: HTMLInputElement) => isValid = checkbox.checked);
        }
        if (!isValid) {
            this.errorMessage = true;
            return;
        }
        // const htmlContent = this.htmlPdfRef.elementRef.nativeElement.parentElement.querySelector('#depositFinalConsentHTML').innerHTML;
        this.dialogRef.close(this.consentHtml);
    }

    print() {
        const iframe = this.iframe.nativeElement;
        iframe.contentDocument.body.innerHTML = '';
        this.portalHost = new DomPortalOutlet(
            iframe.contentDocument.body,
            this.componentFactoryResolver,
            this.appRef,
            this.injector
        );
        const portal = new TemplatePortal(
            this.htmlPdfRef,
            this.viewContainerRef,
            {
                keyIdentifier: this.keyIdentifier,
                headerLogo: this.headerLogo,
                subProductName: this.subProductName,
            }
        );
        const sheet = iframe.contentWindow.document.createElement('style');
        sheet.innerHTML = '@media print {body { -webkit-print-color-adjust: exact; -moz-print-color-adjust: exact;' +
            ' -ms-print-color-adjust: exact;print-color-adjust: exact;}}';
        iframe.contentWindow.document.head.appendChild(sheet);
        this.portalHost.attach(portal);
        iframe.contentWindow.print();
        iframe.contentWindow.onafterprint = () => {
            iframe.contentDocument.body.innerHTML = '';
        };
    }
}
